import { getDocs, query, setDoc } from "firebase/firestore";

import { FirestoreRefs } from "igfd-commons/src/firebase/refs";

import type { DishViewed } from "@dashboard/types";

export interface DishViewedApi {
  // Returns all dishes viewed for the given user.
  fetchDishesViewed(
    userId: string,
    restaurantUuid: string
  ): Promise<DishViewed[]>;

  // Updates an existing dish viewed.
  updateDishViewed(
    userId: string,
    restaurantUuid: string,
    dishViewed: DishViewed
  ): Promise<void>;
}

/**
 * An implementation of the DishViewedApi that uses Firestore as the backend.
 */
export class FirestoreBackedDishViewedApi implements DishViewedApi {
  private readonly firestoreRefs: FirestoreRefs;

  constructor(firestoreRefs: FirestoreRefs) {
    this.firestoreRefs = firestoreRefs;
  }

  public fetchDishesViewed(
    userId: string,
    restaurantUuid: string
  ): Promise<DishViewed[]> {
    return getDocs(
      query(
        this.firestoreRefs.managerRestaurantDishesViewed(userId, restaurantUuid)
      )
    ).then((querySnapshot) =>
      querySnapshot.docs.map((doc) => doc.data() as DishViewed)
    );
  }

  updateDishViewed(
    userId: string,
    restaurantUuid: string,
    dishViewed: DishViewed
  ): Promise<void> {
    return setDoc(
      this.firestoreRefs.dishViewed(userId, restaurantUuid, dishViewed.menuId),
      dishViewed,
      {
        merge: true,
      }
    );
  }
}
